import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';

import _ from 'lodash';

import { Agent } from '../models';
import { LicensePlan } from '../models/license-plan';

@Pipe({
	name: 'licensePlanNameFilter',
	standalone: false,
})
export class LicensePlanNameFilterPipe implements PipeTransform {
	private newBusinessFullIds = CONSTANTS.licensePlans.platinumIds.concat(CONSTANTS.licensePlans.goldIds).concat(CONSTANTS.licensePlans.silverIds);
	private oldBusinessFullIds = CONSTANTS.licensePlans.oldPlatinumIds;
	private businessFullIds = this.newBusinessFullIds.concat(this.oldBusinessFullIds);
	private businessLiteIds = CONSTANTS.licensePlans.businessLiteIds;

	// do not show unless already assigned it
	private showBusinessLite(licensePlan: LicensePlan, agent: Agent) {
		const licensePlanId = Number(licensePlan.id);
		return (
			!this.businessLiteIds.includes(licensePlanId) || // not business lite, return it
			(this.businessLiteIds.includes(licensePlanId) && agent.hasLicensePlan(licensePlanId))
		);
	}

	// do not show unless already assigned it
	private showBusinessNoCharge(licensePlan: LicensePlan, agent: Agent) {
		return (
			!(licensePlan.upfrontFee === 0 && licensePlan.monthlyFee === 0) || // not no charge, return it
			(licensePlan.upfrontFee === 0 && licensePlan.monthlyFee === 0 && agent.hasLicensePlan(licensePlan.id))
		);
	}

	transform(licensePlans: LicensePlan[], agent: Agent, isAdmin: boolean): any {
		if (!licensePlans) {
			return licensePlans;
		}

		return _.orderBy(
			_.uniqBy(licensePlans, l => l.name).filter(
				l => this.businessFullIds.includes(l.id) && this.showBusinessLite(l, agent) && (this.showBusinessNoCharge(l, agent) || isAdmin),
			),
			l => l.sortOrder,
		);
	}
}
